

<script>
import iframeMixin from '../iframeMixin.vue'

export default {
  mixins: [iframeMixin],
  computed: {
    url() {
     return '/ureport/preview?_u=mysql:wz_1.ureport.xml'
    },
  },
}
</script>
